import React, { useState, FC } from 'react';

interface TabProps {
  tabs: { label: string, value: any }[]; 
  onTabClick: (value: any) => void; 
}

const Tab: FC<TabProps> = ({ tabs, onTabClick }) => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    onTabClick(tabs[index].value); 
  };

  return (
    <div>
      <div className="flex border-b-2 mb-4">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`px-6 text-sm font-medium pb-3 pt-1 ${activeTab === index ? 'border-b-2 border-primary/300 text-primary/300 text-body-1' : 'text-gray-500'}`}
            onClick={() => handleTabClick(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Tab;
